import React from 'react';
import { Avatar, CircularProgress } from '@mui/material';
import { useEmployeePhoto } from '../../../hooks/useEmployeePhoto';

export const getInitials = (fullName) => {
  if (!fullName) return '';
  
  return fullName
    .trim()
    .split(' ')
    .filter(name => name.length > 0)
    .slice(0, 2)
    .map(name => name[0])
    .join('')
    .toUpperCase();
};

export const EmployeeAvatar = ({ employee, size = 24, ...props }) => {
  const { photoUrl, isLoading } = useEmployeePhoto(employee?.azureId);
  
  // Calculate font size based on avatar size - smaller ratio for 2-letter initials
  const fontSize = size * 0.45; // Reduced from default ~0.5 to accommodate 2 letters

  if (isLoading && employee?.azureId) {
    return (
      <Avatar
        sx={{ 
          width: size, 
          height: size,
          backgroundColor: 'grey.200',
          ...props.sx
        }}
        {...props}
      >
        <CircularProgress size={size * 0.6} thickness={4} />
      </Avatar>
    );
  }

  return (
    <Avatar
      src={photoUrl}
      alt={employee?.fullName}
      sx={{ 
        width: size, 
        height: size,
        fontSize: fontSize,
        fontWeight: 500,
        ...props.sx
      }}
      {...props}
    >
      {getInitials(employee?.fullName)}
    </Avatar>
  );
}; 